import { render, staticRenderFns } from "./FaceVerificationPage.vue?vue&type=template&id=0bf15b5e&scoped=true"
import script from "./FaceVerificationPage.vue?vue&type=script&lang=js"
export * from "./FaceVerificationPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf15b5e",
  null
  
)

export default component.exports